import React, { useContext, useEffect, useState } from 'react';
import EnhancedTable from '../components/EnhancedTable';
import { getData } from '../utils/apiUtils';
import { getCurrentYear } from '../utils/dateUtils';
import { ErrorContext } from "../utils/constants";

const currentReviewHeadCells = [
  { id: 'initiative_name', numeric: false, disablePadding: false, label: 'Initiative Name' },
  { id: 'status', numeric: false, disablePadding: true, label: 'Status' },
  { id: 'max_date', numeric: false, disablePadding: true, label: 'Due Date', format: 'date' },
  { id: 'netCash', numeric: false, disablePadding: true, label: `Net Cash in ${getCurrentYear()}`, format: 'currency' },
];

export default function ReviewerView()  {
  const [ currentReviews, setCurrentReviews ] = useState([]);
  const [ previousReviews, setPreviousReviews ] = useState([]);
  const { triggerError } = useContext(ErrorContext);

  const onError = () => triggerError({
      title: 'Communication Error',
      description: 'We were unable to read your current and previous reviews data from the server. Please try again.',
      onRetry: () => window.location.reload(),
  });

  const fetchData = () => {
      getData('/dashboards/mycurrentreviews', setCurrentReviews, onError);
      getData('/dashboards/mypreviousreviews', setPreviousReviews, onError);
  };

  useEffect(() => {
    document.title = 'Rise by TransAlta Reviewer Dashboard';
  }, []);

  useEffect(fetchData, []);

  return (
    <main>
      <h2>Initiatives Requiring Your Review</h2>
      Here are the initiatives that are you have been asked to review as a stakeholder.
      <EnhancedTable id='ae9e8eef-87d0-46bb-a18f-69ea6f53ac23'
                     headCells={currentReviewHeadCells}
                     rows={currentReviews}
                     allowExport={true}
                     exportFilename='Initiatives Requiring Your Review'
                     clickData={{url: '/ui/initiativecard/', key: 'id'}}/>
      <p/>
      <h2>Previous Reviews</h2>
      Here is a list of the current initiatives you have previously reviewed.
      <EnhancedTable id='c9390aaa-7544-4fc1-88d3-4fffd116ce8a'
                     headCells={currentReviewHeadCells}
                     rows={previousReviews}
                     allowExport={true}
                     exportFilename='Previous Reviews'
                     clickData={{url: '/ui/initiativecard/', key: 'id'}}/>
    </main>
  );
}
